<template>
  <div ref="container" class="gd-search">
    <div class="gd-search__wrap">
      <div class="gd-search__btn-wrap" ref="wrap">
        <div @click="select(address, true, true)" class="gd-search__btn">
          <svg v-if="!openPersist">
            <use xlink:href="#icon-search-light"></use>
          </svg>
          <p ref="address">Address</p>
        </div>
        <div @click="select(key, false, true)" class="gd-search__btn">
          <p ref="key">Keyword</p>
          <svg v-if="!openPersist">
            <use xlink:href="#icon-key-light"></use>
          </svg>
        </div>
        <div class="gd-search__line" ref="line"></div>
      </div>
      <transition name="slide-up-fade" mode="out-in">
        <div class="gd-search__forms-wrap" v-if="active">
          <transition name="slide-fade" mode="out-in">
            <GetCategory v-if="show" key="1" />
            <NetoSearch v-else key="2" />
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">

import { onMounted, ref, type Ref } from "vue";
import { onClickOutside } from '@vueuse/core'
import NetoSearch from "./NetoSearch.vue";
import GetCategory from "./GetCategory.vue";

interface Props {
  openPersist?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  openPersist: false
})

const show: Ref<boolean> = ref(true);
const address: Ref<HTMLElement | undefined> = ref();
const key: Ref<HTMLElement | undefined> = ref();
const line: Ref<HTMLElement | undefined> = ref();
const active: Ref<boolean> = ref(false);
const container: Ref<HTMLElement | null> = ref(null);

const wrap: Ref<HTMLElement | undefined> = ref();

onClickOutside(container, () => {
  if(props.openPersist) return
  return select(address.value, false, false)
})

function select(
    el: HTMLElement | undefined,
    isShown: boolean,
    isActive: boolean
) {
  if (!el || !line.value || !wrap.value) return;

  show.value = isShown;

  if (!props.openPersist || isActive) {
    active.value = isActive;
  }

  if (active.value) {
    const elRect = el.getBoundingClientRect();
    const wrapRect = wrap.value.getBoundingClientRect();
    line.value.style.width = `${el.offsetWidth}px`;
    line.value.style.left = `${elRect.left - wrapRect.left}px`;
  } else {
    line.value.style.width = '0';
  }
}

onMounted(()=>{
  if(props.openPersist){
    select(address.value, true, true)
  }
})

</script>
